var map = {
	"./DistrictAdmin/Classes/AddClass": [
		61344,
		2614,
		1344
	],
	"./NtnAdmin/Classes/AddClass": [
		3020,
		2614,
		3020
	],
	"./SchoolAdmin/Classes/AddClass": [
		87624,
		2614,
		7624
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 95443;
module.exports = webpackAsyncContext;